import type { MessengerMinimizedViewSettings } from '@widgets/messenger/types'
import { useWidgetStore } from '@widgets/messenger/stores/useWidgetStore'
import { computed } from '@/composition/vue/compositionApi'

export const useWidgetMinimizedViewSettings = () => {
  const { widgetSettings } = useWidgetStore()

  return computed<MessengerMinimizedViewSettings>(() => {
    const { icon, buttonText, buttonTextEnabled, borderRadius, eyeCatcherEnabled, eyeCatcherText, eyeCatcherDelay } =
      widgetSettings.value.appearance.minimizedState

    return {
      icon,
      buttonText: buttonTextEnabled ? buttonText : '',
      borderRadius,
      eyeCatcherText: eyeCatcherEnabled ? eyeCatcherText : '',
      eyeCatcherDelay: eyeCatcherEnabled ? eyeCatcherDelay : 0,
    } satisfies MessengerMinimizedViewSettings
  })
}
